import Reveal from "@/components/Reveal";

const CELLS = [
  {
    num: "01",
    title: "Build",
    copy: "Performance, paint, suspension — WE MAKE IT HAPPEN!",
    img: "/images/purple-car.webp",
    alt: "Purple muscle car with its hood open showing the engine bay",
    span: "md:col-span-2 md:row-span-2",
    imgH: "h-64 sm:h-72 md:h-full",
  },
  {
    num: "02",
    title: "Restore",
    copy: "Bring the dream back to life.",
    img: "/images/engine-stand.webp",
    alt: "Car engine on a stand in the workshop with tools behind",
    span: "",
    imgH: "h-64 sm:h-72 md:h-60",
  },
  {
    num: "03",
    title: "Repair",
    copy: "Whatever the problem is, we can fix it!",
    img: "/images/viper-bay.webp",
    alt: "Viper engine bay with a red intake cover surrounded by tools",
    span: "",
    imgH: "h-64 sm:h-72 md:h-60",
  },
  {
    num: "04",
    title: "Tune",
    copy: "Unlock all things Mopar.",
    img: "/images/engine-cart.webp",
    alt: "Engine placed on a red metal cart with parts shelves behind",
    span: "md:col-span-2",
    imgH: "h-64 sm:h-72 md:h-60",
  },
];

const Cell = ({ cell }) => (
  <div
    data-testid={`capability-cell-${cell.title.toLowerCase()}`}
    className={`group relative flex flex-col overflow-hidden border border-bone/10 bg-charcoal ${cell.span}`}
  >
    <div className="relative overflow-hidden">
      <img
        src={cell.img}
        alt={cell.alt}
        className={`w-full object-cover grayscale-[35%] transition-all duration-500 group-hover:scale-[1.04] group-hover:grayscale-0 ${cell.imgH}`}
      />
      <div className="pointer-events-none absolute inset-0 bg-ink/20" />
    </div>
    <div className="flex flex-1 items-start justify-between gap-4 p-6 sm:p-8">
      <div>
        <h3 className="font-display text-4xl font-black uppercase tracking-[0.02em] text-bone sm:text-5xl">
          {cell.title}
        </h3>
        <p className="mt-2 max-w-sm text-sm leading-relaxed text-bone/70 sm:text-base">
          {cell.copy}
        </p>
      </div>
      <span className="font-display text-2xl font-bold text-steel sm:text-3xl">
        {cell.num}
      </span>
    </div>
  </div>
);

export default function Capabilities() {
  return (
    <section id="services" className="border-y border-bone/10 bg-coal py-24 sm:py-32">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-8">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
          <Reveal className="lg:col-span-7">
            <p className="mb-6 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-bone/60 sm:text-sm">
              <span className="h-px w-10 bg-steel" />
              What We Do
            </p>
            <h2 className="font-display text-5xl font-black uppercase leading-[0.95] tracking-[0.02em] text-bone sm:text-7xl lg:text-8xl">
              Whatever the problem is, we can fix it.
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-4 lg:col-start-9">
            <p className="text-lg leading-relaxed text-bone/85 sm:text-xl">
              We build, restore, repair, tune, and unlock all things Mopar!
              Anything you want, WE CAN DO IT!
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-5 sm:mt-20 md:grid-cols-2 lg:grid-cols-4 lg:grid-rows-2">
          {CELLS.map((cell, i) => (
            <Reveal
              key={cell.num}
              delay={i * 0.08}
              className={cell.span || "lg:col-span-1"}
            >
              <Cell cell={cell} />
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-5">
          <div className="flex flex-col items-start justify-between gap-6 bg-navy px-6 py-10 sm:px-10 md:flex-row md:items-center">
            <p className="font-display text-4xl font-black uppercase leading-none tracking-[0.02em] text-white sm:text-6xl">
              Anything you want,{" "}
              <span className="text-bone/70">we can do it!</span>
            </p>
            <p className="font-display text-xl font-semibold uppercase tracking-wide text-bone/90 sm:text-2xl">
              Let us know your budget &amp; dream, we handle the rest.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
